import Client from 'config/axios';

export const getGroupDataById = async (token: string, id: any) => {
  try {
    const { data } = await Client.get(`group/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return { data };
  } catch (error) {
    return Promise.reject(error.response || error.message);
  }
};
